import { render } from "./VueComponents.vue?vue&type=template&id=a2c07da0&ts=true"
import script from "./VueComponents.vue?vue&type=script&lang=ts"
export * from "./VueComponents.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__